import styles from './MessageBox.module.scss';
import { Button, Text } from '~/shared/components';
import Spinner from '~/shared/components/Spinner/Spinner';

interface ButtonProps {
    text: string;
    onClick(): void;
}

export interface MessageBoxProps {
    headline: string;
    bodyText?: string;
    isLoading?: boolean;
    cta?: ButtonProps;
}

export const PaymentMessageBox: React.FC<MessageBoxProps> = ({
    headline,
    bodyText,
    isLoading,
    cta,
}) => {
    const shouldShowButton = cta && !isLoading;

    return (
        <div className={styles.box}>
            <div className={styles.content}>
                <Text className={styles.headline} variant="large">
                    {headline}
                </Text>

                {bodyText && (
                    <Text className={styles.bodyText} variant="bodySmall">
                        {bodyText}
                    </Text>
                )}

                {isLoading && (
                    <div className={styles.loader}>
                        <Spinner />
                    </div>
                )}

                {shouldShowButton && (
                    <Button className={styles.button} onClick={cta.onClick}>
                        {cta.text}
                    </Button>
                )}
            </div>
        </div>
    );
};
